import { BaseFetch } from "../main-model"
export default class ClassTimeModel extends BaseFetch {
  getClassTimeBy = (data) =>
    this.authFetch({
      url: "class-time/getClassTimeBy",
      method: "POST",
      body: JSON.stringify(data),
    })
    getAdminClassTimeBy = (data) =>
    this.authFetch({
      url: "class-time/getAdminClassTimeBy",
      method: "POST",
      body: JSON.stringify(data),
    })
  getClassTimeById = (data) =>
    this.authFetch({
      url: "class-time/getClassTimeById",
      method: "POST",
      body: JSON.stringify(data),
    })
    updateClassTimeById = (data) =>
    this.authFetch({
      url: "class-time/updateClassTimeById",
      method: "POST",
      body: JSON.stringify(data),
    })
    insertClassTime = (data) =>
    this.authFetch({
      url: "class-time/insertClassTime",
      method: "POST",
      body: JSON.stringify(data),
    })
    deleteClassTimeById = (data) =>
    this.authFetch({
      url: "class-time/deleteClassTimeById",
      method: "POST",
      body: JSON.stringify(data),
    })
}
